// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1ORiK","buttons":"_259tW","buttonIcon":"_36PgB","splitPayment":"mn_MD","title":"_38WXs","loader":"K4OE5","cashier":"_3qdAc"};